import React from "react";
import { ReactComponent as ReviewStarIcon } from "assets/images/common/svgs/reviewStarIcon.svg";
import { ReactComponent as LocationIconSVG } from "assets/images/common/svgs/locationIcon.svg";
import profileImg from "assets/images/common/others/minorImage.png";

interface Review {
  id: number;
  name: string;
  date: string;
  avatar: string;
  review: string;
  eventName?: string;
  eventLocation?: string;
  eventDate?: string;
  rating: number;
}

const reviews: Review[] = [
  {
    id: 1,
    name: "Bella Throne",
    date: "Today",
    avatar: profileImg,
    review:
      "Lorem Ipsum tempor incididunt ut labore et dolore,inise voluptate velit esse cillum...",
    eventName: "Annual Conference on Sport Games.",
    eventLocation: "36 Guild Street London, UK",
    eventDate: "June 12, 2020",
    rating: 4.9,
  },
  {
    id: 2,
    name: "Bella Throne",
    date: "Today",
    avatar: profileImg,
    review:
      "Lorem Ipsum tempor incididunt ut labore et dolore,inise voluptate velit esse cillum...",
    eventName: "Annual Conference on Sport Games.",
    eventLocation: "36 Guild Street London, UK",
    eventDate: "June 12, 2020",
    rating: 4.9,
  },
  {
    id: 3,
    name: "Bella Throne",
    date: "Today",
    avatar: profileImg,
    review:
      "Lorem Ipsum tempor incididunt ut labore et dolore,inise voluptate velit esse cillum...",
    eventName: "Annual Conference on Sport Games.",
    eventLocation: "36 Guild Street London, UK",
    eventDate: "June 12, 2020",
    rating: 4.9,
  },
  {
    id: 4,
    name: "Bella Throne",
    date: "Today",
    avatar: profileImg,
    review:
      "Lorem Ipsum tempor incididunt ut labore et dolore,inise voluptate velit esse cillum...",
    eventName: "Annual Conference on Sport Games.",
    eventLocation: "36 Guild Street London, UK",
    eventDate: "June 12, 2020",
    rating: 4.9,
  },
  {
    id: 5,
    name: "Bella Throne",
    date: "Today",
    avatar: profileImg,
    review:
      "Lorem Ipsum tempor incididunt ut labore et dolore,inise voluptate velit esse cillum...",
    eventName: "Annual Conference on Sport Games.",
    eventLocation: "36 Guild Street London, UK",
    eventDate: "June 12, 2020",
    rating: 4.9,
  },
];

const Reviews = () => {
  return (
    <div className="bg-white border border-mediumGrayBorder rounded-2xl p-6 my-6">
      {reviews.map((review) => (
        <div
          key={review.id}
          className="flex md:flex-nowrap flex-wrap justify-between gap-4 pb-4"
        >
          <div className="flex flex-col gap-1 w-full">
            <div className="flex items-center gap-3">
              <img
                src={review.avatar}
                alt="Avatar"
                className="w-10 h-10 rounded-full object-cover"
              />
              <div>
                <h4 className="font-bold text-black text-xs">{review.name}</h4>
                <p className="text-[10px] text-warmGray">{review.date}</p>
              </div>
            </div>

            <p className="text-uiDarkText text-[12px] ">{review.review}</p>

            {review.eventName && (
              <div>
                <p className="font-medium text-xs text-uiDarkText">
                  {review.eventName}
                </p>
                <div className="flex items-center gap-1 mt-1">
                  <LocationIconSVG className="w-3 h-3" />
                  <span className="text-warmGray text-[10px]">
                    {review.eventLocation}
                  </span>
                </div>
                <p className="text-warmGray text-[10px]">{review.eventDate}</p>
              </div>
            )}
          </div>

          <div className="flex flex-col items-center">
            <div className="flex items-center gap-1">
              {[...Array(5)].map((_, i) => (
                <ReviewStarIcon key={i} className="w-4 h-4" />
              ))}
              <span className="ml-2 text-uiLabelText text-xs">
                ({review.rating})
              </span>
            </div>
          </div>
        </div>
      ))}
    </div>
  );
};

export default Reviews;
